import {
    Box,
    Button,
    Grid,
    Modal,
    Typography,
    TextField,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment
} from '@mui/material';
import React, { useContext, useState, useEffect } from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { getTeacherList, savecreateClub, saveCreateSport, savecreateAcademic, saveSocialWork, getStudentProfile } from '../../../../../../Utils/apiService';
import { AuthContext } from '../../../../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../../../../interfaces/Contexts';
import KenLoader from '../../../../../../GlobalComponents/KenLoader';

const useStyles = makeStyles((theme: Theme) => ({
    extraCuricularBox: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '10px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    categoriesTitle: {
        fontSize: '15px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    categoriesBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '5px !important',
        marginTop: '10px !important',
        cursor: 'pointer',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            marginTop: '5px !important',
            padding: '5px !important',
        },
    },
    clubsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    sportsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    socialWorkBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    academicsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    AddButton: {
        background: 'linear-gradient(90deg, #3061FF -15.54%, #30C1FF 133.56%)',
        color: '#FFFFFF !important',
        borderRadius: '8px !important',
    },
    clubsTitle: {
        fontSize: '14px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    clubsContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    td: {
        fontSize: '12px !important',
        fontWeight: '400 !important',
        textAlign: 'left',
        padding: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        width: '400px',
        maxWidth: '90vw',
        position: 'relative',
        outline: 'none',
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#333333',
    },
    closeButton: {
        color: '#666666',
        cursor: 'pointer',
    },
    formField: {
        marginBottom: '16px !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
        },
        '& .MuiSelect-select': {
            borderRadius: '8px',
        },
        '& .MuiPopover-root': {
            zIndex: 9999,
        },
    },
    dateField: {
        marginBottom: '16px !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#3061FF',
            },
        },
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: '#3061FF',
            },
        },
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '24px',
        gap: '12px',
    },
    cancelButton: {
        backgroundColor: '#EAEFFF !important',
        color: '#2C58E8 !important',
        borderRadius: '8px',
        textTransform: 'none',
        flex: 1,
        '&:hover': {
            backgroundColor: '#E0E0E0',
        },
    },
    submitButton: {
        backgroundColor: '#3061FF',
        color: '#FFFFFF',
        borderRadius: '8px',
        textTransform: 'none',
        flex: 1,
        '&:hover': {
            backgroundColor: '#1E4BD8',
        },
    },
    fileUploadField: {
        '& .MuiOutlinedInput-root': {
            cursor: 'pointer',
        },
    },
    viewCertificateButton: {
        color: '#3061FF !important',
        textTransform: 'none',
        fontSize: '12px !important',
        padding: '4px 8px !important',
        minWidth: 'auto !important',
        '&:hover': {
            backgroundColor: 'transparent !important',
            textDecoration: 'underline',
        },
    },
    roleText: {
        fontSize: '12px !important',
        color: '#666666 !important',
        fontWeight: '400 !important',
    },
    dateText: {
        fontSize: '12px !important',
        color: '#666666 !important',
        fontWeight: '400 !important',
        textAlign: 'right',
    },
    descriptionText: {
        fontSize: '12px !important',
        color: '#666666 !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        marginTop: '4px !important',
    },
}));

const categoriesData = [
    { title: 'Clubs' },
    { title: 'Sports' },
    { title: 'Social work' },
    { title: 'Academics' },
];

// API endpoints for different categories
const API_ENDPOINTS = {
    Clubs: '/api/clubs',
    Sports: '/api/sports',
    'Social work': '/api/social-work',
    Academics: '/api/academics',
};

const ExtraCurricular = (props: any) => {
    console.log(props?.props?.data, "propspropspropsprops12321");
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [categoriesValue, setCategoriesValue] = useState('Clubs');
    const [localData, setLocalData] = useState(props?.props?.data);
    const [formData, setFormData] = useState({
        // Clubs fields
        clubName: '',
        facultyIncharge: '',

        // Sports fields
        sportName: '',
        role: '',
        startDate: null,
        endDate: null,
        sportCertificate: null,

        // Social work fields
        eventName: '',
        description: '',
        socialRole: '',
        socialCertificate: null,

        // Academics fields
        awardName: '',
        awardDate: null,
        awardDescription: '',
        academicCertificate: null,
    });

    const [teacherList, setTeacherList] = useState<any[]>([]);

    // Update local data when props change
    useEffect(() => {
        setLocalData(props?.props?.data);
    }, [props?.props?.data]);

    // Extract data from props
    const apiData = localData || {};
    const clubsData = apiData?.club || [];
    const achievementsData = apiData?.achievements || [];
    // const socialWorkData = apiData?.socialWork || [];

    // Filter achievements by RecordType.Name
    const sportsData = achievementsData.filter((achievement: any) =>
        achievement.RecordType?.Name === 'Sports'
    );
    const academicsData = achievementsData.filter((achievement: any) =>
        achievement.RecordType?.Name === 'Academics'
    );
    const socialWorkData = achievementsData.filter((achievement: any) =>
        achievement.RecordType?.Name === 'Social Work'
    );

    // Helper function to format date
    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    // Helper function to format date range
    const formatDateRange = (startDate: string, endDate: string) => {
        const start = formatDate(startDate);
        const end = endDate ? formatDate(endDate) : 'present';
        return `${start} - ${end}`;
    };

    // Show all categories regardless of data availability
    const allCategories = [
        { title: 'Clubs' },
        { title: 'Sports' },
        { title: 'Social work' },
        { title: 'Academics' },
    ];

    // Set default category if current one is not available
    React.useEffect(() => {
        if (allCategories.length > 0 && !allCategories.find((cat: any) => cat.title === categoriesValue)) {
            setCategoriesValue(allCategories[0].title);
        }
    }, [allCategories, categoriesValue]);

    const handleOpen = () => {
        getTeacherList().then((res) => {
            setTeacherList(res?.records || []);
        });
        setOpen(true);

    };
    const handleClose = () => {
        setOpen(false);
        // Reset form data when closing
        setFormData({
            clubName: '',
            facultyIncharge: '',
            sportName: '',
            role: '',
            startDate: null,
            endDate: null,
            sportCertificate: null,
            eventName: '',
            description: '',
            socialRole: '',
            socialCertificate: null,
            awardName: '',
            awardDate: null,
            awardDescription: '',
            academicCertificate: null,
        });
    };

    const handleInputChange = (field: string, value: any) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
        const file = event.target.files?.[0];
        if (file) {
            try {
                const base64 = await convertFileToBase64(file);
                setFormData(prev => ({
                    ...prev,
                    [field]: base64
                }));
            } catch (error) {
                console.error('Error converting file to base64:', error);
            }
        }
    };

    const convertFileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result as string;
                // Remove the data URL prefix to get just the base64 string
                const base64 = base64String.split(',')[1];
                resolve(base64);
            };
            reader.onerror = error => reject(error);
        });
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            let response = null;

            switch (categoriesValue) {
                case 'Clubs':
                    const clubPayload = {
                        Name: formData.clubName,
                        facultyId: formData.facultyIncharge,
                        contactId: localData?.studentDetails[0]?.Id
                    };
                    response = await savecreateClub(clubPayload);
                    break;

                case 'Sports':
                    const sportPayload = {
                        Name: formData.sportName,
                        StartDate: formData.startDate ? dayjs(formData.startDate).format('YYYY-MM-DD') : '',
                        Role: formData.role,
                        fileName: formData.sportCertificate ? 'sport_certificate.pdf' : '',
                        base64File: formData.sportCertificate || ''
                    };
                    response = await saveCreateSport(localData?.studentDetails[0]?.Id, sportPayload);
                    break;

                case 'Social work':
                    const socialWorkPayload = {
                        Name: formData.eventName,
                        Description: formData.description,
                        Role: formData.socialRole,
                        fileName: formData.socialCertificate ? 'social_work_certificate.pdf' : '',
                        base64File: formData.socialCertificate || ''
                    };
                    response = await saveSocialWork(localData?.studentDetails[0]?.Id, socialWorkPayload);
                    break;

                case 'Academics':
                    const achievementPayload = {
                        Name: formData.awardName,
                        StartDate: formData.awardDate ? dayjs(formData.awardDate).format('YYYY-MM-DD') : '',
                        Description: formData.awardDescription,
                        Place: '1st Place', // You might want to make this dynamic
                        fileName: formData.academicCertificate ? 'academic_certificate.pdf' : '',
                        base64File: formData.academicCertificate || ''
                    };
                    response = await savecreateAcademic(localData?.studentDetails[0]?.Id, achievementPayload);
                    break;
            }

            if (response) {
                handleClose();
                const updatedData = await getStudentProfile(localData?.studentDetails[0]?.Id);
                if (updatedData?.data) {
                    setLocalData(updatedData.data);
                    if (props?.props?.onDataUpdate) {
                        props.props.onDataUpdate(updatedData.data);
                    }   
                }
                handleClose();
            } else {
                console.error('Failed to submit data');
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const renderModalContent = () => {
        switch (categoriesValue) {
            case 'Clubs':
                return (
                    <>
                        <TextField
                            fullWidth
                            label="Name of club"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.clubName}
                            onChange={(e) => handleInputChange('clubName', e.target.value)}
                        />
                        <FormControl fullWidth className={classes.formField}>
                            <InputLabel>Faculty incharge</InputLabel>
                            <Select
                                value={formData.facultyIncharge}
                                label="Faculty incharge"
                                onChange={(e) => handleInputChange('facultyIncharge', e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: "35%",
                                            zIndex: 9999,
                                        },
                                    },
                                }}
                            >
                                {teacherList.map((teacher) => (
                                    <MenuItem key={teacher.Id} value={teacher.Id}>
                                        {teacher.Name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                );

            case 'Sports':
                return (
                    <>
                        <TextField
                            fullWidth
                            label="Name of the sport"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.sportName}
                            onChange={(e) => handleInputChange('sportName', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Enter role"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.role}
                            onChange={(e) => handleInputChange('role', e.target.value)}
                        />
                        <DatePicker
                            label="Select start date"
                            value={formData.startDate}
                            onChange={(newValue) => handleInputChange('startDate', newValue)}
                            className={classes.dateField}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: 'outlined',
                                    className: classes.dateField,
                                },
                            }}
                        />
                        <DatePicker
                            label="Select end date"
                            value={formData.endDate}
                            onChange={(newValue) => handleInputChange('endDate', newValue)}
                            className={classes.dateField}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: 'outlined',
                                    className: classes.dateField,
                                },
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Upload certificate"
                            variant="outlined"
                            className={`${classes.formField} ${classes.fileUploadField}`}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CloudUploadIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            onClick={() => document.getElementById('sport-certificate-upload')?.click()}
                        />
                        <input
                            id="sport-certificate-upload"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileUpload(e, 'sportCertificate')}
                            accept=".pdf,.jpg,.jpeg,.png"
                        />
                    </>
                );

            case 'Social work':
                return (
                    <>
                        <TextField
                            fullWidth
                            label="Event name"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.eventName}
                            onChange={(e) => handleInputChange('eventName', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Description"
                            variant="outlined"
                            multiline
                            rows={3}
                            className={classes.formField}
                            value={formData.description}
                            onChange={(e) => handleInputChange('description', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Enter role"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.socialRole}
                            onChange={(e) => handleInputChange('socialRole', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Upload certificate"
                            variant="outlined"
                            className={`${classes.formField} ${classes.fileUploadField}`}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CloudUploadIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            onClick={() => document.getElementById('social-certificate-upload')?.click()}
                        />
                        <input
                            id="social-certificate-upload"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileUpload(e, 'socialCertificate')}
                            accept=".pdf,.jpg,.jpeg,.png"
                        />
                    </>
                );

            case 'Academics':
                return (
                    <>
                        <TextField
                            fullWidth
                            label="Name of the award"
                            variant="outlined"
                            className={classes.formField}
                            value={formData.awardName}
                            onChange={(e) => handleInputChange('awardName', e.target.value)}
                        />
                        <DatePicker
                            label="Select date"
                            value={formData.awardDate}
                            onChange={(newValue) => handleInputChange('awardDate', newValue)}
                            className={classes.dateField}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: 'outlined',
                                    className: classes.dateField,
                                },
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Description"
                            variant="outlined"
                            multiline
                            rows={3}
                            className={classes.formField}
                            value={formData.awardDescription}
                            onChange={(e) => handleInputChange('awardDescription', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Upload certificate"
                            variant="outlined"
                            className={`${classes.formField} ${classes.fileUploadField}`}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CloudUploadIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            onClick={() => document.getElementById('academic-certificate-upload')?.click()}
                        />
                        <input
                            id="academic-certificate-upload"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileUpload(e, 'academicCertificate')}
                            accept=".pdf,.jpg,.jpeg,.png"
                        />
                    </>
                );

            default:
                return null;
        }
    };

    const renderContentArea = () => {
        switch (categoriesValue) {
            case 'Clubs':
                return (
                    <>
                        {clubsData.length > 0 ? (
                            clubsData.map((club: any, index: number) => (
                                <Box key={club.Id} className={classes.clubsBox}>
                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <Typography className={classes.clubsTitle}>
                                                {club.Club__r?.Name || 'Club Name Not Available'}
                                            </Typography>
                                            <Typography className={classes.clubsContent}>
                                                {club.Club__r?.Faculty_Incharge__r?.Name || 'Faculty Not Assigned'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))
                        ) : (
                            <Box className={classes.clubsBox}>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Typography className={classes.clubsContent}>
                                            No clubs data available
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </>
                );

            case 'Sports':
                return (
                    <>
                        {sportsData.length > 0 ? (
                            sportsData.map((sport: any, index: number) => (
                                <Box key={sport.Id} className={classes.sportsBox}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={8}>
                                            <Typography className={classes.clubsTitle}>
                                                {sport.Organisation_Name__c || 'Sport Name Not Available'}
                                            </Typography>
                                            <Typography className={classes.descriptionText}>
                                                {formatDateRange(sport.Start_Date__c, sport.End_Date__c)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign="right">
                                            <Typography className={classes.roleText}>
                                                Role: {sport.Role__c || 'Role Not Available'}
                                            </Typography>
                                            <Button className={classes.viewCertificateButton}>View Certificate</Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))
                        ) : (
                            <Box className={classes.sportsBox}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={8}>
                                        <Typography className={classes.clubsContent}>
                                            No sports data available
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </>
                );

            case 'Social work':
                return (
                    <>
                        {socialWorkData.length > 0 ? (
                            socialWorkData.map((socialWork: any, index: number) => (
                                <Box key={socialWork.Id} className={classes.socialWorkBox}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={8}>
                                            <Typography className={classes.clubsTitle}>
                                                {socialWork.Organisation_Name__c || 'Event Title Not Available'}
                                            </Typography>
                                            <Typography className={classes.descriptionText}>
                                                {socialWork.Description__c || 'No description available'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign="right">
                                            <Button className={classes.viewCertificateButton}>View Certificate</Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))
                        ) : (
                            <Box className={classes.socialWorkBox}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={8}>
                                        <Typography className={classes.clubsContent}>
                                            No social work data available
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </>
                );

            case 'Academics':
                return (
                    <>
                        {academicsData.length > 0 ? (
                            academicsData.map((achievement: any, index: number) => (
                                <Box key={achievement.Id} className={classes.academicsBox}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={8}>
                                            <Typography className={classes.clubsTitle}>
                                                {achievement.Organisation_Name__c || 'Achievement Title Not Available'}
                                            </Typography>
                                            <Typography className={classes.descriptionText}>
                                                {achievement.Description__c || 'No description available'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign="right">
                                            <Typography className={classes.dateText}>
                                                {formatDate(achievement.Start_Date__c) || 'Date Not Available'}
                                            </Typography>
                                            <Button className={classes.viewCertificateButton}>View Certificate</Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))
                        ) : (
                            <Box className={classes.academicsBox}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={8}>
                                        <Typography className={classes.clubsContent}>
                                            No academic achievements available
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {isLoading && <KenLoader />}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} xl={4} lg={4} xxl={4}>
                    <Box className={`${classes.extraCuricularBox} scrollbar-cusgray`}>
                        <Typography className={classes.categoriesTitle}>Categories</Typography>
                        {allCategories?.map((val: any, index: number) => {
                            return (
                                <Box
                                    key={index}
                                    className={classes.categoriesBox}
                                    onClick={() => setCategoriesValue(val?.title)}
                                    sx={{ border: categoriesValue === val?.title ? '1px solid #2C58E8' : '' }}
                                >
                                    <Typography className={classes.td}>{val?.title}</Typography>
                                </Box>
                            );
                        })}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={8} lg={8} xxl={8}>
                    <Box className={`${classes.extraCuricularBox} scrollbar-cusgray`}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography className={classes.categoriesTitle}>{categoriesValue}</Typography>
                            </Grid>
                            <Grid item xs={6} display={'flex'} justifyContent={'end'}>
                                <Button size="small" variant="contained" className={classes.AddButton} onClick={handleOpen}>
                                    + Add
                                </Button>
                            </Grid>
                        </Grid>
                        {renderContentArea()}
                    </Box>
                </Grid>

                {/* Modal */}
                <Modal
                    open={open}
                    onClose={handleClose}
                    className={classes.modal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className={classes.modalContent}>
                        <Box className={classes.modalHeader}>
                            <Typography className={classes.modalTitle}>
                                Add {categoriesValue.toLowerCase()}
                            </Typography>
                            <IconButton onClick={handleClose} className={classes.closeButton}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {renderModalContent()}

                        <Box className={classes.modalActions}>
                            <Button
                                // variant="contained" 
                                className={classes.cancelButton}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className={classes.submitButton}
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            </Grid>
        </LocalizationProvider>
    );
};

export default ExtraCurricular;